// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Milestone  {
    _originalTypeClassName = "Loom.BO.Milestone";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Milestone.translate = translateService;
}
this.WorkPackages = [];
this.Id = null;
this.Number = null;
this.Title = null;
this.MeansOfVerification = null;
this.DueMonth = null;
this.DueDate = null;
this.WorkPackagesAsString = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Number:any;
Title:any;
MeansOfVerification:any;
DueMonth:any;
DueDate:any;
WorkPackagesAsString:any;
WorkPackages:any;
Project:any;
Lead:any;
static setWorkPackages = ($this, items) => {
                if (items == null) items = [];
                if ($this.WorkPackages == null) $this.WorkPackages = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WorkPackages.length > 0) {
                    Domain.Milestone.removeWorkPackages($this, $this.WorkPackages[0]);
                }

                Domain.Milestone.addManyWorkPackages($this, copyItems);
            }
static addManyWorkPackages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Milestone.addWorkPackages($this, items[i]);
                }
            }
static addWorkPackages = ($this, item) => {
                if ($this.WorkPackages == null) $this.WorkPackages = [];
                if (item == null || $this.WorkPackages.indexOf(item) > -1) return;
                $this.WorkPackages.push(item);
}
static addRangeWorkPackages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Milestone.addWorkPackages($this, item));
            }
static removeWorkPackages = ($this, item) => {
                if ($this == null || $this.WorkPackages == null || $this.WorkPackages.indexOf(item) === -1) return;
                var _index = $this.WorkPackages.indexOf(item);
                $this.WorkPackages.splice(_index, 1);
}
static clearWorkPackages = ($this) => { $this.WorkPackages = null; }
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeMilestones(oldValue, $this);
}
Domain.Project.addMilestones(value, $this);
}
}
static setLead = ($this, value) => {
var oldValue = $this.Lead;
$this.Lead = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectParticipant.removeMilestonesLed(oldValue, $this);
}
Domain.ProjectParticipant.addMilestonesLed(value, $this);
}
}

static GetDueDate($this: any): any{return Domain.Project.GetMonthDates($this?.Project, $this?.DueMonth)[1];
}
static GetWorkPackagesAsString($this: any): any{return CLMS.Framework.String.Join(", ", $this?.WorkPackages?.linq?.select((a) => a?.WPNumber)?.toArray());
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}